// extracted by mini-css-extract-plugin
export default {"blockquote":"blockquote-module__blockquote__6B0C3"};